import { getPlayers } from './players.backend';
import { put } from 'redux-saga/effects';
import { fetchPlayersFail, fetchPlayersSuccess } from './actions';
import { makeErrorPayload } from '../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../shared/toast/redux/actions';

export function* fetchPlayersSaga(action) {
    try {
        const response = yield getPlayers(action.payload);
        yield put(fetchPlayersSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchPlayersFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
